const openInNewTab = (url) => window.open(url, "_blank");

export default openInNewTab;



// WEBPACK FOOTER //
// ./src/utils/open-in-new-tab.js